import { AuthFlow } from '@griply/types';
import { confirmPasswordReset } from 'firebase/auth';

import { getAuthentication, handleAuthError } from './helpers';

export const resetPassword = async (code: string, password: string) => {
  const auth = await getAuthentication();

  try {
    await confirmPasswordReset(auth, code, password);
  } catch (e) {
    throw handleAuthError(e, AuthFlow.ResetPassword);
  }
};
